import {PracticeId} from "../../constants/practiceIds";
import monolith from "../../utils/fetch/fetches";

type GetAvailabilityRequest = {
  patientId?: string;
  timezone: string;
  locationId: string;
  virtual: boolean;
  specialtyId: string;
  from: number; // epoch ms
  to: number; // epoch ms
  apptReasonId: string;
  practiceId?: string;
};

type GetAvailabilityResponse = ApptSlot[][];
export type ApptSlot = {
  allowHouseCall: boolean;
  confirmed?: boolean;
  createdAt: number;
  deleted: boolean;
  doctorId: string;
  duration: number;
  id: string;
  locationId: string;
  recurringRangeId?: string;
  slotIds: string[];
  specialtyIds: string[];
  time: number;
  totalDuration: number;
  walkInOnly: boolean;
};

/**
 * Get openings directly from the API. This will be slower than the cloudflare cache
 * (fetchCachedSlots), but the data it returns will be up-to-date.
 */
export async function fetchSlots(
  request: GetAvailabilityRequest,
): Promise<GetAvailabilityResponse> {
  const body = {
    ...defaults,
    ...request,
  };
  const response = await monolith()("/hib/getAppointmentSlots", {
    method: "POST",
    body: JSON.stringify(body),
  });
  return response.json();
}

const defaults = {
  practiceId: PracticeId.CARBON,
} as const;
